import React from 'react';
import "./aboutus.css";
import { 
  FaBullseye, 
  FaEye, 
  FaHandshake, 
  FaMedal, 
  FaLightbulb, 
  FaHeart, 
  FaUsers, 
  FaLinkedin, 
  FaTwitter, 
  FaFacebook,
  FaRocket,
  FaGlobe,
  FaChartLine
} from 'react-icons/fa';
import { MdVerified, MdSecurity } from 'react-icons/md';
import { GiAchievement } from 'react-icons/gi';

function AboutUs() {
  const teamMembers = [
  {
    name: "Dhammika Deshapriya",
    position: "CEO & Founder",
    image: "/leadership/1.jpg"
  },
  {
    name: "Naresh Pradhan",
    position: "Operations Director",
    image: "/leadership/2.jpg"
  },
  {
    name: "Thejan Balawickrama",
    position: "Technical Lead",
    image: "/leadership/3.jpg"
  },
  {
    name: "N. Muhammad",
    position: "Customer Relations",
    image: "/leadership/4.jpg"
  },

  // Committee Members
  {
    name: "R H Namali",
    position: "Committee Member",
    image: "/leadership/c1.jpg"
  },
  {
    name: "Sadun Bamunusinghe",
    position: "Committee Member",
    image: "/leadership/c2.jpg"
  },
  {
    name: "Eranda Nadeeshan",
    position: "Committee Member",
    image: "/leadership/c3.jpg"
  },
  {
    name: "Erandi Siriwardhane",
    position: "Committee Member",
    image: "/leadership/c4.jpg"
  }
];

  const coreValues = [
    {
      icon: <FaHandshake />,
      title: "Integrity",
      description: "We conduct our business with the highest ethical standards and transparency."
    },
    {
      icon: <FaMedal />,
      title: "Excellence",
      description: "We strive for excellence in everything we do, delivering quality beyond expectations."
    },
    {
      icon: <FaLightbulb />,
      title: "Innovation",
      description: "We embrace innovation and continuously seek better ways to serve our clients."
    },
    {
      icon: <FaHeart />,
      title: "Customer First",
      description: "Our customers' success is our success. We put their needs at the heart of our business."
    }
  ];

  return (
    <div className="aboutus-container">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="about-hero-content">
          <h1>
            Welcome to <span>Optica International</span>
          </h1>
          <p>
            Empowering businesses worldwide with innovative solutions and unwavering commitment to excellence. 
            With over a decade of experience, we've been at the forefront of digital transformation, 
            helping our clients achieve their goals and exceed expectations.
          </p>
        </div>
      </section>

      {/* Mission & Vision Section */}
      <section className="mission-vision-section">
        <div className="container">
          <div className="mission-vision-grid">
            <div className="mission-card">
              <div className="card-icon">
                <FaBullseye />
              </div>
              <h2>Our Mission</h2>
              <p>
                To deliver exceptional value to our clients through innovative solutions, 
                unwavering dedication, and a commitment to excellence. We strive to build 
                lasting partnerships that drive mutual growth and success in an ever-evolving 
                global marketplace.
              </p>
            </div>
            <div className="vision-card">
              <div className="card-icon">
                <FaEye />
              </div>
              <h2>Our Vision</h2>
              <p>
                To be the global leader in providing comprehensive business solutions, 
                recognized for our innovation, integrity, and impact. We envision a future 
                where businesses of all sizes can access world-class solutions that drive 
                sustainable growth and success.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Company Story Section */}
      <section className="company-story">
        <div className="container">
          <div className="story-content">
            <div className="story-text">
              <h2>Our Story</h2>
              <p>
                Founded in 2011, Optica International began with a simple vision: to bridge the gap 
                between businesses and technology. What started as a small team of passionate 
                individuals has grown into a global organization serving clients across five continents.
              </p>
              <p>
                Our journey has been marked by continuous growth, learning, and adaptation. We've 
                evolved with the changing times while staying true to our core values. Today, we 
                stand proud as a trusted partner to hundreds of businesses worldwide, helping them 
                navigate the complexities of the modern business landscape.
              </p>
              <div className="story-stats">
                <div className="stat-item">
                  <div className="stat-number">15+</div>
                  <div className="stat-label">Years of Excellence</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">50+</div>
                  <div className="stat-label">Happy Members</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">17+</div>
                  <div className="stat-label">Team Members</div>
                </div>
              </div>
            </div>
            <div className="story-image">
              <img 
                src="/logo512.png" 
                alt="optica international"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Core Values Section */}
      <section className="core-values">
        <div className="container">
          <h2 className="section-title-aboutus">Our Core Values</h2>
          <div className="values-grid">
            {coreValues.map((value, index) => (
              <div key={index} className="value-card">
                <div className="value-icon">{value.icon}</div>
                <h3>{value.title}</h3>
                <p>{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="team-section">
  <div className="container">

    {/* Leadership Team */}
    <h2 className="section-title">Meet Our Leadership Team</h2>

    <div className="team-grid">
      {teamMembers.slice(0, 4).map((member, index) => (
        <div key={index} className="team-card">
          <div className="team-image">
            <img src={member.image} alt={member.name} />
          </div>

          <div className="team-info">
            <h3>{member.name}</h3>
            <div className="team-position">{member.position}</div>

            <div className="team-social">
              <a href="#" className="social-link"><FaLinkedin /></a>
              <a href="#" className="social-link"><FaTwitter /></a>
              <a href="#" className="social-link"><FaFacebook /></a>
            </div>
          </div>
        </div>
      ))}
    </div>

    {/* Committee Members */}
    <h2 className="section-title committee-title">Committee Members</h2>

    <div className="team-grid">
      {teamMembers.slice(4).map((member, index) => (
        <div key={index} className="team-card">
          <div className="team-image">
            <img src={member.image} alt={member.name} />
          </div>

          <div className="team-info">
            <h3>{member.name}</h3>
            <div className="team-position">{member.position}</div>

            <div className="team-social">
              <a href="#" className="social-link"><FaLinkedin /></a>
              <a href="#" className="social-link"><FaTwitter /></a>
              <a href="#" className="social-link"><FaFacebook /></a>
            </div>
          </div>
        </div>
      ))}
    </div>

  </div>
</section>


    </div>
  );
}

export default AboutUs;